import React from "react";
import { connect } from "react-redux";
import { XS_MOBILE, SM_MOBILE, MD_TABLET } from "../../../../constants/textConstants";
import { Typography } from "../../../ecosystem";

const mapStateToProps = (state) => {
    return {
        screenBreakPoint: state.common.screenBreakPoint
    }
};

export const CareGapsQuestionHeading = connect(mapStateToProps)(({
    question,
    screenBreakPoint
}) => {

    const isMobile = ([XS_MOBILE, SM_MOBILE]).indexOf(screenBreakPoint) > -1 ? true : false;

    return (
        <div className="row care-gaps-question-heading-container">
            <div className="col-12">
                <Typography
                    color={"$color-primary-a2"}
                    tag="h2"
                    type={isMobile ? "body-02" : "heading-05"}
                    responsive
                >
                    {question}
                </Typography>
            </div>
        </div> 
    )
});